import React from "react";
import { Link } from "react-router-dom";

function LendingMoney() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-lending-money">
      <div className="container d-flex flex-column align-items-end justify-content-end vh-45 w-100">
            <div className="row d-flex justify-content-end align-items-end my-auto text-center w-30">
                <div className="bg-white rounded-border py-2 px-5 border border-4 border-dark">
                    <div className="col-12 heading-font">
                        <h1 className="mb-0">Lending Money</h1>
                    </div>
                </div>
            </div>
        </div>
        <div className="container d-flex flex-column align-items-end justify-content-end vh-45 w-100">
            <Link  to={'/choose-a-simulation'} 
                    className="btn btn-warning float-center btn-lg px-5 border-3 border-white fw-bold inner-shadow w-25 mt-2 ">
                    Let’s Go!
            </Link>
        </div>
      </div>
    </>
  );
}

export default LendingMoney;
